/// <reference path="AppHelper.ts" />

interface AppHelper
{
    showAddLedgerAccountAlert( vc:MUIViewController, name:string, completion:any ) : void ;
    showAddAnalyticAccountAlert( vc:MUIViewController, name:string, completion:any ) : void ;
    showAddBankMovementConceptAlert( vc:MUIViewController, name:string, completion:any ) : void ;
    analyticAccountTreeItems() : { accounts:AnalyticAccount[], levels:number[] } ;
}

// Flattened analytic account tree (each account right below its parent), for combo boxes
AppHelper.prototype.analyticAccountTreeItems = function() : { accounts:AnalyticAccount[], levels:number[] }
{
    let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("title", true)];
    let objects = DBHelper.queryObjectsFromMainContext("AnalyticAccount", sortDescriptors, null) as AnalyticAccount[];

    let roots = [];
    let childrenByParent = {};
    for (let index = 0; index < objects.length; index++){
        let account = objects[index];
        let parent = account.parent;
        if (parent == null) {
            roots.push(account);
        }
        else {
            if (childrenByParent[parent.identifier] == null) childrenByParent[parent.identifier] = [];
            childrenByParent[parent.identifier].push(account);
        }
    }

    let accounts:AnalyticAccount[] = [];
    let levels:number[] = [];
    let appendBranch = function(account:AnalyticAccount, level:number){
        accounts.push(account);
        levels.push(level);
        let children = childrenByParent[account.identifier];
        if (children == null) return;
        for (let index = 0; index < children.length; index++){
            appendBranch(children[index], level + 1);
        }
    };

    for (let index = 0; index < roots.length; index++){
        appendBranch(roots[index], 0);
    }

    return { accounts: accounts, levels: levels };
}

AppHelper.prototype.showAddLedgerAccountAlert = function( vc:MUIViewController, nameValue:string = null, completion:any = null) : void
{
    let avc = new MUIAlertViewController();
    avc.initWithTitle(MIOLocalizeString("NEW_LEDGER_ACCOUNT", "NEW LEDGER ACCOUNT"), MIOLocalizeString("CHOOSE_A_NAME", "CHOOSE A NAME"), MUIAlertViewStyle.Default);
    avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
        if (nameValue != null) textField.text = nameValue;
        else textField.setPlaceholderText(MIOLocalizeString("NAME","NAME"));
    });
    
    avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){        
        textField.setPlaceholderText(MIOLocalizeString("PREFIX","PREFIX"));
    });

    avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('ADD','ADD'), MUIAlertActionStyle.Default, this, function(){
        let nameTF = avc.textFields[0];
        let name = nameTF.text.trim();

        let prefixTF = avc.textFields[1];
        let prefix = prefixTF.text.trim();

        if (name.length > 0 && prefix.length > 0) {
            let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;
            let newLedgerAccount = MIOEntityDescription.insertNewObjectForEntityForName("LedgerAccount", moc) as LedgerAccount;
            newLedgerAccount.identifier = MIOUUID.UUID().UUIDString;
            newLedgerAccount.name = name;
            newLedgerAccount.normalizedAccountPrefix = prefix;
            moc.save();
            if (completion) completion(newLedgerAccount);
        }
        else {
            let error = new MUIAlertViewController();
            error.initWithTitle(MIOLocalizeString('ERROR', 'ERROR'), MIOLocalizeString("CHECK_NAME_AND_PREFIX", "CHECK NAME AND PREFIX"), MUIAlertViewStyle.Default);
            error.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','Cancel'), MUIAlertActionStyle.Cancel, this, function(){}));
            
            this.presentViewController(error, true);
        }
    }));

    avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','Cancel'), MUIAlertActionStyle.Cancel, this, function(){}));
    
    if (vc != null) {
        vc.presentViewController(avc, true);
    }
    else {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.window.rootViewController.presentViewController(avc, true);
    }

}

AppHelper.prototype.showAddAnalyticAccountAlert = function( vc:MUIViewController, nameValue:string = null, completion:any = null) : void
{
    // Tree order (each account right below its parent) is built in memory, like AnalyticAccountViewController
    let tree = this.analyticAccountTreeItems();
    let accounts = tree.accounts;
    let levels = tree.levels;

    let avc = new MUIAlertViewController();
    avc.initWithTitle(MIOLocalizeString("NEW_ANALYTIC_ACCOUNT", "NEW ANALYTIC ACCOUNT"), MIOLocalizeString("CHOOSE_A_NAME", "CHOOSE A NAME"), MUIAlertViewStyle.Default);
    avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
        if (nameValue != null) textField.text = nameValue;
        else textField.setPlaceholderText(MIOLocalizeString("NAME","NAME"));
    });

    avc.addComboBoxWithConfigurationHandler(this, function(comboBox:MUIComboBox){
        comboBox.removeAllItems();
        comboBox.addItem(MIOLocalizeString("NO_PARENT_ROOT_ACCOUNT", "NO PARENT (ROOT ACCOUNT)"), -1);
        for (let index = 0; index < accounts.length; index++){
            let indent = "";
            for (let level = 0; level < levels[index]; level++) indent += "   ";
            comboBox.addItem(indent + accounts[index].title, index);
        }
        comboBox.selectItem(-1);
    });

    // Whether movements on this account also require a document link to be complete
    avc.addComboBoxWithConfigurationHandler(this, function(comboBox:MUIComboBox){
        comboBox.removeAllItems();
        comboBox.addItem(MIOLocalizeString("LINK_NOT_REQUIRED", "LINK NOT REQUIRED"), 0);
        comboBox.addItem(MIOLocalizeString("LINK_REQUIRED", "LINK REQUIRED"), 1);
        comboBox.selectItem(0);
    });

    avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('ADD','ADD'), MUIAlertActionStyle.Default, this, function(){
        let name = avc.textFields[0].text.trim();

        if (name.length > 0) {
            let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;

            let parentIndex = parseInt(avc.comboBoxes[0].getSelectedItem());
            let parent = parentIndex >= 0 ? accounts[parentIndex] : null;

            let predicate = MIOPredicate.predicateWithFormat(parent != null ? "parent.identifier == '" + parent.identifier + "'" : "parent == null");
            let siblings = DBHelper.queryObjectsFromMainContext("AnalyticAccount", null, predicate);

            let account = MIOEntityDescription.insertNewObjectForEntityForName("AnalyticAccount", moc) as AnalyticAccount;
            account.identifier = MIOUUID.UUID().UUIDString;
            account.title = name;
            account.parent = parent;
            account.indexPath = parent != null ? parent.indexPath + "." + siblings.length : siblings.length.toString();
            account.requiredLink = parseInt(avc.comboBoxes[1].getSelectedItem()) == 1;
            moc.save();
            if (completion) completion(account);
        }
        else {
            let error = new MUIAlertViewController();
            error.initWithTitle(MIOLocalizeString('ERROR', 'ERROR'), MIOLocalizeString("CHECK_NAME", "CHECK NAME"), MUIAlertViewStyle.Default);
            error.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','Cancel'), MUIAlertActionStyle.Cancel, this, function(){}));

            this.presentViewController(error, true);
        }
    }));

    avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','Cancel'), MUIAlertActionStyle.Cancel, this, function(){}));

    if (vc != null) {
        vc.presentViewController(avc, true);
    }
    else {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.window.rootViewController.presentViewController(avc, true);
    }

}

AppHelper.prototype.showAddBankMovementConceptAlert = function( vc:MUIViewController, nameValue:string = null, completion:any = null) : void
{
    let tree = this.analyticAccountTreeItems();
    let accounts = tree.accounts;
    let levels = tree.levels;

    let avc = new MUIAlertViewController();
    avc.initWithTitle(MIOLocalizeString("NEW_BANK_MOVEMENT_CONCEPT", "NEW BANK MOVEMENT CONCEPT"), MIOLocalizeString("CHOOSE_A_NAME_AND_AN_ANALYTIC_ACCOUNT", "CHOOSE A NAME AND AN ANALYTIC ACCOUNT"), MUIAlertViewStyle.Default);
    avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
        if (nameValue != null) textField.text = nameValue;
        else textField.setPlaceholderText(MIOLocalizeString("NAME","NAME"));
    });

    // The analytic account is fixed on the concept: picking the concept is what categorizes the difference
    avc.addComboBoxWithConfigurationHandler(this, function(comboBox:MUIComboBox){
        comboBox.removeAllItems();
        comboBox.addItem(MIOLocalizeString("SELECT_ANALYTIC_ACCOUNT", "SELECT ANALYTIC ACCOUNT"), -1);
        for (let index = 0; index < accounts.length; index++){
            let indent = "";
            for (let level = 0; level < levels[index]; level++) indent += "   ";
            comboBox.addItem(indent + accounts[index].title, index);
        }
        comboBox.selectItem(-1);
    });

    avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('ADD','ADD'), MUIAlertActionStyle.Default, this, function(){
        let name = avc.textFields[0].text.trim();
        let accountIndex = parseInt(avc.comboBoxes[0].getSelectedItem());
        let account = accountIndex >= 0 ? accounts[accountIndex] : null;

        if (name.length > 0 && account != null) {
            let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;
            let concept = MIOEntityDescription.insertNewObjectForEntityForName("BankMovementConcept", moc) as BankMovementConcept;
            concept.identifier = MIOUUID.UUID().UUIDString;
            concept.name = name;
            concept.analyticAccount = account;
            concept.analyticAccountName = account.title;
            moc.save();
            if (completion) completion(concept);
        }
        else {
            let error = new MUIAlertViewController();
            error.initWithTitle(MIOLocalizeString('ERROR', 'ERROR'), MIOLocalizeString("CHECK_NAME_AND_ANALYTIC_ACCOUNT", "CHECK NAME AND ANALYTIC ACCOUNT"), MUIAlertViewStyle.Default);
            error.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','Cancel'), MUIAlertActionStyle.Cancel, this, function(){}));

            this.presentViewController(error, true);
        }
    }));

    avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','Cancel'), MUIAlertActionStyle.Cancel, this, function(){}));

    if (vc != null) {
        vc.presentViewController(avc, true);
    }
    else {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.window.rootViewController.presentViewController(avc, true);
    }

}
